import { render } from "./DevToolsPanel.vue?vue&type=template&id=a40b541a&scoped=true"
import script from "./DevToolsPanel.vue?vue&type=script&lang=js"
export * from "./DevToolsPanel.vue?vue&type=script&lang=js"

import "./DevToolsPanel.vue?vue&type=style&index=0&id=a40b541a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a40b541a"]])

export default __exports__